/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import {
    CONFIRMATION_BOX_BTN_IDS,
} from './confirmationDialogConstants';
import CONFIRMATION_CTAS_REPO from './confirmationDialogActionsRepo';
import {
    AppDialogAction, AppDialogDescription, AppDialogInput,
} from '../../../../stores/dialog';
import TranslationUtil from '../../../translation';
import AppModelMapper from '..';
import { APP_DIALOG } from '../../../enums';
import './confirmationDialog.scss';


class LaunchConfirmationModelMapper {
    getInputList = (confirmationCheckboxes) => {
        if (!Array.isArray(confirmationCheckboxes)) {
            // eslint-disable-next-line no-param-reassign
            confirmationCheckboxes = [confirmationCheckboxes];
        }

        const inputList = [];
        if (confirmationCheckboxes.length && confirmationCheckboxes[0].value === 'dontShowAgain') {
            const { id } = confirmationCheckboxes[0];
            const localizeLabel = TranslationUtil.getMessage('ccx.confirmation.checkbox.dontShowAgain');

            inputList.push(new AppDialogInput({
                id,
                type: APP_DIALOG.INPUT_TYPE.CHECKBOX,
                localizedText: localizeLabel,
                ariaLabel: localizeLabel,
                onChange: (v) => {
                    // eslint-disable-next-line no-param-reassign
                    confirmationCheckboxes[0].selected = v ? 'true' : 'false';
                },
            }));
        }
        return inputList;
    }

    updateDialogRepo(appData) {
        const { confirmationDetails } = appData;
        const { confirmationCheckboxes = {}, confirmationButtons } = confirmationDetails;

        const heading = TranslationUtil.getMessage('ccx.confirmation.launch.title',
            {
                actionName: AppModelMapper.actionCommandToStatusString(appData, true),
                appName: appData.display_name,
            });
        // TODO: Need string for this
	    const launchDialogDesc = TranslationUtil.getMessage('ccx.confirmation.launch.desc');
        const description = [
            new AppDialogDescription(APP_DIALOG.DESCRIPTION_TYPE.PARAGRAPH, launchDialogDesc),
        ];

        const actionList = [];
        confirmationButtons.map((btnInConfirmationBox) => {
            if (!btnInConfirmationBox.id) {
                return null;
            }
            switch (btnInConfirmationBox.id.toLowerCase()) {
            case CONFIRMATION_BOX_BTN_IDS.PRIMARY:
	            actionList.push(new AppDialogAction({
		            localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.continue'),
		            ariaLabel: 'Continue',
		            ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.PRIMARY],
	            }));
	            break;
            case CONFIRMATION_BOX_BTN_IDS.SECONDARY:
	            actionList.push(new AppDialogAction({
		            localizedText: TranslationUtil.getMessage('ccx.confirmation.btn.cancel'),
		            ariaLabel: 'Cancel',
		            ...CONFIRMATION_CTAS_REPO[CONFIRMATION_BOX_BTN_IDS.SECONDARY],
	            }));
	            break;
            default:
                break;
            }
            return null;
        });

        const inputList = this.getInputList(confirmationCheckboxes);

        return {
            heading, description, actionList, inputList,
        };
    }
}
export default new LaunchConfirmationModelMapper();
